import { clsx } from "clsx";
import { Link, useParams } from "react-router";

import type { ChainEntry } from "@/features/feed/types";
import { formatPostDate } from "@/features/feed/utils/format";

interface ChainTimelineProps {
	chain: ChainEntry[];
	currentId: string;
}

export function ChainTimeline({ chain, currentId }: ChainTimelineProps) {
	const { obra: obraKey } = useParams();

	return (
		<div className="chain-timeline">
			<span className="chain-timeline__heading">Histórico do relato</span>
			<ol className="chain-timeline__list">
				{chain.map((entry) => {
					const current = entry.id === currentId;
					const content = (
						<>
							<span className="chain-timeline__title">{entry.title}</span>
							<span className="chain-timeline__date">
								{formatPostDate(entry.date)}
							</span>
						</>
					);
					return (
						<li
							key={entry.id}
							className={clsx("chain-timeline__item", current && "is-current")}
						>
							<span className="chain-timeline__dot" />
							{current ? (
								<span className="chain-timeline__entry">{content}</span>
							) : (
								<Link
									to={`/${obraKey}/feed/${entry.id}`}
									className="chain-timeline__entry"
								>
									{content}
								</Link>
							)}
						</li>
					);
				})}
			</ol>
		</div>
	);
}
